var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1090_34342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.70312 -1.57593H88.7008L90 44L88.7008 89.828H-2.70312V-1.57593Z",
    fill: "url(#paint0_linear_1090_34342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.832 53.5H36.4987C36.4987 56.56 40.3804 59.1667 44.9987 59.1667C49.617 59.1667 53.4987 56.56 53.4987 53.5C53.4987 50.3833 50.552 49.25 44.3187 47.7483C38.312 46.2467 30.832 44.3767 30.832 36.5C30.832 31.4283 34.997 27.1217 40.7487 25.6767V19.5H49.2487V25.6767C55.0004 27.1217 59.1654 31.4283 59.1654 36.5H53.4987C53.4987 33.44 49.617 30.8333 44.9987 30.8333C40.3804 30.8333 36.4987 33.44 36.4987 36.5C36.4987 39.6167 39.4454 40.75 45.6787 42.2517C51.6854 43.7533 59.1654 45.6233 59.1654 53.5C59.1654 58.5717 55.0004 62.8783 49.2487 64.3233V70.5H40.7487V64.3233C34.997 62.8783 30.832 58.5717 30.832 53.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1090_34342",
    x1: 11.5,
    y1: 6.5,
    x2: 67,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5063E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736BF7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1090_34342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 89,
    rx: 44.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStable);
export default __webpack_public_path__ + "static/media/stable.dc94d7ee31c5186c0f99211d169be146.svg";
export { ForwardRef as ReactComponent };